export const sortRegranulaty = () => {
    const ajaxUrl = window.ajaxurl || '/wp-admin/admin-ajax.php';

    let currentSortField = '';
    let currentSortOrder = 'ASC';

    const getResults = () => document.querySelector('.js-products-results');
    const getForm = () => document.querySelector('.js-products-filter');

    const getSortField = (cell) => {
        if (!cell) return null;

        const text = cell.textContent.trim().toLowerCase();
        if (text.includes('materiał')) return 'material';
        if (text.includes('gęstość')) return 's2_gestosc';
        if (text.includes('mfi')) return 's2_mfi';

        return null;
    };

    const buildFormData = (field, order) => {
        const formData = new FormData();
        const form = getForm();

        formData.append('action', 'filter_regranulat');
        formData.append('sort_field', field);
        formData.append('sort_order', order);

        if (window.productsFilterNonce) {
            formData.append('nonce', window.productsFilterNonce);
        }

        if (form) {
            form.querySelectorAll('input[type="checkbox"]:checked').forEach((input) => {
                formData.append(input.name, input.value);
            });
        }

        return formData;
    };

    const fetchSorted = async (field) => {
        const results = getResults();

        if (!results || !field) return;

        if (currentSortField === field) {
            currentSortOrder = currentSortOrder === 'ASC' ? 'DESC' : 'ASC';
        } else {
            currentSortField = field;
            currentSortOrder = 'ASC';
        }

        results.classList.add('is-loading');

        try {
            const response = await fetch(ajaxUrl, {
                method: 'POST',
                body: buildFormData(currentSortField, currentSortOrder),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const html = await response.text();
            const freshResults = getResults();

            if (freshResults) {
                freshResults.outerHTML = html;
            }
        } catch (error) {
            console.error('Sort error:', error);
        }
    };

    document.addEventListener('click', (e) => {
        const icon = e.target.closest('.product-sort');

        if (!icon) return;

        const cell = icon.closest('.products-table__cell');
        const field = getSortField(cell);

        if (!field) return;

        e.preventDefault();
        fetchSorted(field);
    });
};